import { useEffect } from 'react'
import { useEdgeDataFetcherDealer, useEdgeGetDealerInfoOfCobrandingGroup, useEdgeGetCobrandingGroupInfo } from './useEdgeDataFetcher'
import { getCobrandingOEMImage } from '../services/oemService'
import { XML_FORMAT_MAZDA, XML_FORMAT_STELLANTIS } from '../constants'
import { getSuperComponentTheme } from '../utils/kbbUtils'

export default (landingContext, globalState) => {
  //move everything to global state
  const [groupDealer, groupDealerError] = useEdgeGetDealerInfoOfCobrandingGroup(landingContext.experienceState.groupId, landingContext.experienceState.dealerId)
  const dealerId = groupDealer ? groupDealer.dealerId : !landingContext.experienceState.groupId && landingContext.experienceState.dealerId
  //hack to fix edge bug. accepts rv should be properly returned in group dealer array
  const [dealer, dealerError] = useEdgeDataFetcherDealer(dealerId)

  useEffect(() => {
    if (landingContext?.experienceState?.isAdmin && !landingContext?.experienceState?.customerInfo?.zip && landingContext?.experienceState?.useDealerZip && dealer?.zipCode) {
      globalState.zip = dealer?.zipCode
      globalState.useDealerZip = true
      landingContext.experienceState.customerInfo.zip = dealer?.zipCode
    }
  }, [dealerId])
  const {
    environment: { ico_directToKBBDealerId, ico_directToKBBDealerIdv2 }
  } = globalState

  const useDealerInfo = (dealer || groupDealer) && {
    ...groupDealer,
    ...dealer,
    acceptsReplacementVehicleAnswers: dealer && dealer.acceptsReplacementVehicleAnswers && (groupDealer ? groupDealer.acceptsReplacementVehicleAnswers : true)
  }

  const [groupCobrandingInfo, groupError] = useEdgeGetCobrandingGroupInfo(!(useDealerInfo && useDealerInfo.cobrandingGroup) && landingContext.experienceState.groupId)
  const cobrandingInfo = (useDealerInfo && useDealerInfo.cobrandingGroup) || groupCobrandingInfo

  const fetchCobrandingImage = async (groupKey, itemKey) => {
    const result = await getCobrandingOEMImage({
      globalState,
      params: { groupKey, itemKey }
    })

    const imageUrl = result?.data?.data?.items && result.data.data.items[0]?.getContentsUrl
    if (!imageUrl) {
      landingContext.experienceState.cobrandingInfo.imageUrl = 'assets/main-image-kbb.svg'
    } else {
      landingContext.experienceState.cobrandingInfo.imageUrl = `${imageUrl}?${Date.now()}`
    }
  }

  const setSuperComponentTheme = experienceState => {
    if (!experienceState) {
      return ''
    }

    const { isCobrand, shouldShowOfferCreationComponent, cobrandingInfo, urlTheme } = experienceState
    const { superComponentTheme, isSuperComponent } = cobrandingInfo || {}

    if (isCobrand && isSuperComponent && shouldShowOfferCreationComponent) {
      const themeName = getSuperComponentTheme(urlTheme, superComponentTheme)
      landingContext.experienceState.theme = themeName
    } else {
      landingContext.experienceState.theme = ''
    }
  }

  useEffect(() => {
    if (!cobrandingInfo) return

    const internalGroupID = cobrandingInfo.internalGroupID
    const groupKey = `cobranding_${internalGroupID}`
    const itemKey = 'cobranding_landing_page.png'
    fetchCobrandingImage(groupKey, itemKey)
  }, [cobrandingInfo])

  const reassignMeasurementId = measurementId => {
    landingContext.experienceState.measurementId = measurementId
    if (window.ICO && window.ICO.dataLayer) {
      // Fix issue acs page view event not fire when first load or reload page
      window.ICO.dataLayer.measurementId = landingContext.experienceState.measurementId
    }
  }
  setSuperComponentTheme(landingContext.experienceState)

  //Unassigned cobrand or inactive
  if (useDealerInfo || groupCobrandingInfo) {
    const cobrandingInfo = (useDealerInfo && useDealerInfo.cobrandingGroup) || groupCobrandingInfo
    landingContext.experienceState.cobrandingInfo = cobrandingInfo
    landingContext.experienceState.isInactiveDealer = landingContext.experienceState.isInactiveDealer || (useDealerInfo && useDealerInfo.dealerGuid === '00000000-0000-0000-0000-000000000000')
    landingContext.experienceState.isInactiveDealer = landingContext.experienceState.isInactiveDealer || (groupCobrandingInfo && !groupCobrandingInfo.enabled)
    landingContext.experienceState.isInactiveDealer = landingContext.experienceState.isInactiveDealer || (useDealerInfo && useDealerInfo.cobrandingGroup && !useDealerInfo.cobrandingGroup.enabled)
    landingContext.experienceState.isCobrandDR = cobrandingInfo && cobrandingInfo.isDigitalRetailer
    landingContext.experienceState.isRequireVinPlate = cobrandingInfo && cobrandingInfo.isRequireVinPlate
    landingContext.experienceState.allowIneligibleVehicle = cobrandingInfo && cobrandingInfo.allowIneligibleVehicle
  }
  //Assigned cobrand or normal
  if (useDealerInfo) {
    if (!landingContext.experienceState.isInactiveDealer && useDealerInfo.subscriptionSourceLevels && !landingContext.experienceState.isAdmin) {
      var listLevelID = []
      const KBBSource = 4,
        AuctionSource = 2,
        UpsideLevel = 7
      useDealerInfo.subscriptionSourceLevels.forEach(element => {
        if ((element.sourceID === KBBSource || element.sourceID === AuctionSource) && element.levelValue) {
          listLevelID.push(element.levelID)
        }
      })

      if (useDealerInfo && useDealerInfo.cobrandingGroup && useDealerInfo.cobrandingGroup.isOEMAppraisal && useDealerInfo.subscriptionSourceLevels.find(sub => (sub.sourceID === KBBSource || sub.sourceID === AuctionSource) && sub.levelID === UpsideLevel)) {
        landingContext.experienceState.isInactiveDealer = false
      } else {
        landingContext.experienceState.isInactiveDealer = listLevelID.length === 1 && listLevelID[0] === UpsideLevel
      }

      if (!landingContext.experienceState.isInactiveDealer) {
        const cobranding = (useDealerInfo && useDealerInfo.cobrandingGroup) || groupCobrandingInfo
        const cobrandingOEMAppraisal = !!cobranding && cobranding.isOEMAppraisal
        const oemAppraisal = useDealerInfo.subscriptionSourceLevels.find(sub => (sub.sourceID === KBBSource || sub.sourceID === AuctionSource) && sub.levelID === 8) // OEM Appraisal
        landingContext.experienceState.isInactiveDealer = !!oemAppraisal && !cobrandingOEMAppraisal
      }
    }

    //TODO //WARNING The following two lines are done this way to resolve assigned offeres not being assigned at submission. we should figure out a way to clean this up JM 8/12/19
    const dealerGuidQx = landingContext.qxData.find(question => question.questionId === 'qx/SiteReferralUserID')
    if (dealerGuidQx) dealerGuidQx.value = useDealerInfo.dealerGuid

    // Check if dealer is Direct to KBB (Sell2KBB)
    landingContext.experienceState.dealerIsDirectToKBB = useDealerInfo.dealerGuid === ico_directToKBBDealerId
    landingContext.experienceState.dealerIsDirectToKBBv2 = useDealerInfo.dealerGuid === ico_directToKBBDealerIdv2
    if (landingContext.qxData && !landingContext.qxData.find(question => question.questionId === 'qx/SVOCID')) {
      landingContext.qxData.push({
        questionId: 'qx/SVOCID',
        value: useDealerInfo.dealerId
      })
    }

    // Check if dealer is the KBYC dealer
    landingContext.experienceState.dealerIsKbycDealer = useDealerInfo.dealerGuid === ico_directToKBBDealerId

    landingContext.experienceState.dealerGuid = useDealerInfo.dealerGuid
    landingContext.experienceState.dealerId = useDealerInfo.dealerId
    landingContext.experienceState.dealerName = useDealerInfo.displayName
    landingContext.experienceState.dealerPhone = useDealerInfo.phone
    landingContext.experienceState.acceptsRV = useDealerInfo.acceptsReplacementVehicleAnswers
    landingContext.experienceState.dealerGroups = useDealerInfo.dealerGroups
    landingContext.experienceState.isStellantisDealer = useDealerInfo.xmlFormat === XML_FORMAT_STELLANTIS
    landingContext.experienceState.isMazdaDealer = useDealerInfo.xmlFormat === XML_FORMAT_MAZDA
    landingContext.experienceState.oemDealerCode = useDealerInfo.oemDealerCode
    landingContext.experienceState.isToyotaDealer = useDealerInfo.displayName.toString().toLowerCase().includes('toyota')
    landingContext.experienceState.isLexusDealer = useDealerInfo.displayName.toString().toLowerCase().includes('lexus')
    landingContext.experienceState.isGMDealer =
      useDealerInfo.displayName.toString().toLowerCase().includes('chevrolet') ||
      useDealerInfo.displayName.toString().toLowerCase().includes('buick') ||
      useDealerInfo.displayName.toString().toLowerCase().includes('gmc') ||
      useDealerInfo.displayName.toString().toLowerCase().includes('cadillac')
    landingContext.experienceState.isGenesisDealer = useDealerInfo.displayName.toString().toLowerCase().includes('genesis')
    if (landingContext.experienceState.groupId && groupDealer?.measurementId && landingContext.experienceState.measurementId !== groupDealer.measurementId) {
      reassignMeasurementId(groupDealer.measurementId)
    } else if (!landingContext.experienceState.groupId && dealer?.measurementId && landingContext.experienceState.measurementId !== dealer.measurementId) {
      reassignMeasurementId(dealer.measurementId)
    }
  } else if ((groupDealerError && groupDealerError[0]) || (groupError && groupError[0]) || (dealerError && dealerError[0])) {
    //If the call fails it should show dealer inactive
    landingContext.experienceState.isInactiveDealer = true
  }
}
